import React from 'react';
import styled from '@emotion/styled';
import { EditItemProps } from '../../toolympus/api/useNewItem';
import { ProjectStatus } from './types';
import { FormGrid, SimpleDialog, useCopyText } from '../../toolympus/components/primitives';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { FieldType, Schema } from '../../toolympus/hooks/useSchema';
import { Typography } from '@mui/material';

export interface ProjectStatusEdit extends ProjectStatus {
  previous_description?: string;
  project_title: string;
  status_date_label: string;
  status_prev_date_label: string;
  which: "current" | "prev";
}

const StatusEditSchema: Schema = {
  description: { type: FieldType.textlong, label: "Задачи" },
  previous_description: { type: FieldType.textlong, label: "Задачи" },
  alert: { type: FieldType.bool, label: "Обратить внимание" },
}

interface Props {
  data: EditItemProps<ProjectStatusEdit>;
}

export const ProjectStatusEditDialog = (props: Props) => {
  const { data } = props;
  const copyText = useCopyText();

  return (
    <SimpleDialog
      {...data.dialog}
      noFullscreen
      submitOnModEnter
      dialogTitle={`Задачи ${data.item?.status_date_label || ""} (${data.item?.project_title || "..."})`}
      save={() => data.save()}
      simpleExtraActions={<>
        <Typography variant="caption" color="textSecondary">
          сохранить: cmd/ctrl+Enter
        </Typography>
      </>}>
      <Grid columns="1fr" noMargin>
        {data.item?.which === "current" && <>
            <FormControlsForFields
              data={data.item}
              onChange={(o,c) => data.update(c)}
              fields={[
                ["previous_description", {
                  readOnly: true,
                  label: `Задачи ${data.item?.status_prev_date_label || ""}`,
                  className: "previous",
                  onWrapperClick: () => copyText(data.item?.previous_description || ""),
                }],
              ]}
              schema={StatusEditSchema}
              />
          </>}

        <FormControlsForFields
          data={data.item}
          onChange={(o,c) => data.update(c)}
          fields={[
            ["description", { label: `Задачи ${data.item?.status_date_label || ""}`, controlProps: { autoFocus: true }}],
            data.item?.which === "current"
              ? ["alert", {}]
              : null,
          ]}
          schema={StatusEditSchema}
          />
          
      </Grid>
    </SimpleDialog>
  );
}

const Grid = styled(FormGrid)`
  & .previous {
    opacity: 0.7;
    margin-bottom: 2rem;
    filter: grayscale(1);
  }
`;